import React, { useState, useEffect, useContext } from 'react';
import {
	Switch,
	Route,
	useHistory,
	matchPath,
	useLocation,
} from 'react-router-dom';
import NewHeaders from '../Header/NewHeaders';
import Filter from '../Filter/Filter';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import CatmanView from '../Filter/CatmanView/index';
import { Box } from '@mui/material';
import HeaderStyles from '../Header/HeaderStyles';
import { saveWeekFilter } from '../../redux/actions/salesActions';
import { setComparisonChartTimePeriod } from '../../redux/actions/chartComparisonActions';
import {
	OMNI,
	AI_INSIGHTS,
	DASHBOARD,
	INSIGHTS,
	BOGLE_BOLD,
	STANDARDVIEW,
	MAIN_INSIGHTS_DASHBOARD,
} from '../../constants/constant';
import { useDispatch, useSelector } from 'react-redux';
import PoweredAI from '../PoweredAI';
import { ApolloProvider } from '@apollo/client';
import apolloClient from '../../apollo/guidedInsights';
import { UserPortalContext } from '../../context/appcontext';
import { getWeekFilterDateRange } from '../Filter/util.js';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
import analytics from '../../helper/analytics';

const TabbedLayout = () => {
	const [selectedFilter, setSelectedFilter] = useState(OMNI);
	const dispatch = useDispatch();

	const portalUserContext = useContext(UserPortalContext);

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);

	const channelFilter = selectedFilters?.selectedFilter;

	const sessionWeekFilters = JSON.parse(sessionStorage.getItem('weekfilters'));

	const { weekFilter, startWeek, endWeek, startDate, endDate } =
		sessionWeekFilters && Object.keys(sessionWeekFilters)?.length != 0
			? sessionWeekFilters
			: selectedFilters;

	const handleWeekFilterChange = ({ target }) => {
		dispatch(saveWeekFilter(target));
	};

	const useRouteMatch = (patterns) => {
		const { pathname } = useLocation();
		let possibleMatch;
		for (let i = 0; i < patterns.length; i++) {
			const pattern = patterns[i];
			possibleMatch = matchPath(pattern, {
				path: pathname,
				exact: true,
			});
			if (possibleMatch !== null) {
				return i;
			}
		}
		return 0;
	};

	// You should add the same tabs endpoints here (Maintaining the same index order)
	const currentTab = useRouteMatch([
		'/dashboard',
		'/dashboard/guided-insights',
	]);
	const [tabIndex, setTabIndex] = useState(currentTab);
	const navigate = useHistory();
	const isCatmanUser = useSelector((state) => state.appGuideReducer.isCatman);
	const classes = HeaderStyles();
	const tabName = tabIndex === 0 ? DASHBOARD : AI_INSIGHTS;

	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	useEffect(() => {
		setSelectedFilter(channelFilter);
	}, [channelFilter]);

	// Watch for currentTab changes and set the Tab Index
	useEffect(() => {
		setTabIndex(currentTab);
	}, [currentTab]);

	const handleChange = (e, value) => {
		setTabIndex(value);
		switch (value) {
			case 0:
				navigate.push('/dashboard');
				break;

			case 1:
				goToGI();
				break;
			default:
				navigate.push('/dashboard');
		}
	};

	const goToGI = () => {
		let enableApply = true;

		if (endWeek >= startWeek) {
			enableApply = endWeek - startWeek + 1 < 4 ? false : true;
		} else {
			enableApply = endWeek - (startWeek - 52) + 1 < 4 ? false : true;
		}

		if (
			weekFilter === 0 ||
			weekFilter === 1 ||
			(weekFilter === -1 && !enableApply)
		) {
			const data = { weekFilter: 13 };
			const { startDate, endDate } = getWeekFilterDateRange(data);

			// update session storage once switch to GI
			const weekFilters = {
				weekFilter: 13,
				startWeek: null,
				endWeek: null,
				startDate: startDate,
				endDate: endDate,
				selectedFilter: 'Store',
			};

			sessionStorage.setItem('weekfilters', JSON.stringify(weekFilters));

			// set it to weekly the timeperiod for comparison chart when navigate to GI
			const payload = {
				timePeriod: 'Weekly',
			};
			dispatch(setComparisonChartTimePeriod(payload));

			dispatch(
				saveWeekFilter({
					...selectedFilters,
					weekFilter: 13,
					startDate: startDate,
					endDate: endDate,
					startWeek: null,
					endWeek: null,
				})
			);
		} else {
			dispatch(
				saveWeekFilter({
					...selectedFilters,
					selectedFilter: 'Store',
				})
			);
		}
		const request = {
			event: 'AI Insights Launched',
			event_description: 'AI Insights Tab',
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));

		//Adobe event : Track the page
		analytics.trackPageInfo('AI Insights Tab');

		navigate.push('/dashboard/guided-insights');
	};

	const StyledTabs = styled((props) => (
		<Tabs
			data-test="tabs"
			data-testid="tabs"
			{...props}
			TabIndicatorProps={{
				children: <span className="MuiTabs-indicatorSpan" />,
			}}
		/>
	))({
		'& .MuiTabs-indicator': {
			borderRadius: '3px 3px 0px 0px',
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: '#6245B7',
			height: '3px',
		},
		'& .MuiTabs-indicatorSpan': {
			maxWidth: 10,
			width: '10%',
			backgroundColor: '#635ee7',
		},
	});

	const StyledTab = styled((props) => <Tab disableRipple {...props} />)(() => ({
		textTransform: 'none',
		fontFamily: 'Bogle',
		fontSize: '14px',
		color: 'black',
		marginLeft: '-10px',
		'&.Mui-selected': {
			color: 'black',
			fontWeight: '700',
		},
		'&.MuiButtonBase-root': {
			paddingLeft: '16px',
			paddingRight: '16px',
			paddingBottom: '0px',
			paddingTop: '0px',
		},
		'&.Mui-focusVisible': {
			backgroundColor: 'black',
		},
	}));

	return (
		<div>
			<Box className={classes.headerInsights}>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}>
					<Box
						style={{
							fontFamily: BOGLE_BOLD,
							fontSize: '24px',
							marginLeft: '12px',
							marginBottom: '10px',
						}}>
						{INSIGHTS}
					</Box>
					{tabName !== AI_INSIGHTS && (
						<Box style={{ marginRight: '50px', marginTop: '4px' }}>
							{isCatmanUser && <CatmanView />}
						</Box>
					)}
				</Box>

				<Box>
					{selectedView !== STANDARDVIEW ? (
						<StyledTabs
							value={tabIndex}
							onChange={handleChange}
							aria-label="dashboard-insights">
							<StyledTab data-test="dashboard" label={DASHBOARD} />
						</StyledTabs>
					) : (
						<StyledTabs
							value={tabIndex}
							onChange={handleChange}
							aria-label="dashboard-insights">
							<StyledTab data-test="dashboard" label={DASHBOARD} />
							<StyledTab data-test="guidedInsights" label={AI_INSIGHTS} />
						</StyledTabs>
					)}
				</Box>
			</Box>

			<Box style={{ marginTop: '25px', width: '100%' }}>
				<Filter
					weekFilter={weekFilter}
					setWeekFilter={handleWeekFilterChange}
					setSelectedFilter={setSelectedFilter}
					selectedFilter={selectedFilter}
					startWeek={startWeek}
					endWeek={endWeek}
					startDate={startDate}
					endDate={endDate}
					isItemDrilldown={false}
				/>
			</Box>

			<ApolloProvider client={apolloClient}>
				<Switch>
					<Route path="/dashboard" exact component={NewHeaders}></Route>
					<Route
						path="/dashboard/guided-insights"
						exact
						component={PoweredAI}></Route>
				</Switch>
			</ApolloProvider>
		</div>
	);
};

export default TabbedLayout;
